import { CircularProgress, Button as MuiButton, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

const PROGRESS_SIZE = '1.2rem';

function Button(props: {
    fullWidth?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    children: string | ReactNode;
    variant?: 'contained' | 'outlined' | 'text';
    disabled?: boolean;
    type?: 'submit';
    title?: string;
    startIcon?: JSX.Element;
    endIcon?: JSX.Element;
    isLoading?: boolean;
    loadingText?: string;
    color?: 'primary' | 'secondary' | 'error' | 'inherit' | 'success' | 'warning';
}) {
    return (
        <MuiButton
            color={props.color}
            title={props.title}
            startIcon={props.startIcon}
            endIcon={props.endIcon}
            type={props.type}
            fullWidth={props.fullWidth}
            variant={props.variant}
            onClick={props.onClick}
            disabled={props.disabled || props.isLoading}
        >
            {renderButtonContent()}
        </MuiButton>
    );

    function renderButtonContent() {
        if (props.isLoading) {
            if (props.loadingText) {
                return [
                    <CircularProgress color="inherit" size={PROGRESS_SIZE} />,
                    <LoadingText>{props.loadingText}</LoadingText>,
                    <CircularProgress color="inherit" size={PROGRESS_SIZE} />,
                ];
            } else {
                return <CircularProgress color="inherit" size={PROGRESS_SIZE} />;
            }
        }
        return props.children;
    }
}

const LoadingText = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
}));
export { Button };
